<template>
  <scout-form
    :is-modified="!!value"
    :half="half"
    label="会員IDを選択"
    :explanation="explanation"
  >
    <input
      :value="value"
      class="boss-input"
      type="number"
      :max="intMax"
      min="0"
      data-test="text-box"
      @keypress="onlyNumberInRange($event,intMax)"
      @input="$emit('input', Number($event.target.value) || null)"
    >
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'
import eventValidations from '@/lib/eventValidations'

export default {
  components: {
    ScoutForm
  },
  mixins: [eventValidations],
  props: {
    value: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    },
    half: {
      default: false,
      type: Boolean
    },
    explanation: {
      default: '',
      type: String
    }
  },
  computed: {
    intMax: () => 2147483647
  }
}
</script>
